module.exports = __webpack_public_path__ + "static/img/tab2-active.7a3f8d9c.jpg";